import { enumID2Name } from 'common/CommonConstants';

// NOTE! Order here is also how parent status is determined
export enum StatusItemState {
  GREEN = 1, // OK
  YELLOW = 2, // Warning
  RED = 3, // Error
  GRAY = 4, // Unknown - This should not be used for anything else than when we really have nothing, or ??
}

export const statusItemStateName = enumID2Name<StatusItemState>(StatusItemState);

export const ServiceTextStatus2StatusItemState = {
  green: 1,
  yellow: 2,
  red: 3,
  gray: 4,
};

export const StatusItemStateTexts = {
  [StatusItemState.GREEN]: 'green',
  [StatusItemState.YELLOW]: 'yellow',
  [StatusItemState.RED]: 'red',
  [StatusItemState.GRAY]: 'gray',
} as const;

export enum StatusItemType {
  CORE = 1,
  PROJECT = 100,
  PROJECT_SETUP = 110,
  PROJECT_SETUP_INIT = 120,
  DEPLOYMENT = 200,
  DEPLOYMENT_SETUP = 210,
  DEPLOYMENT_SETUP_INIT = 220,
  DEPLOYMENT_SETUP_STORAGE = 230,
  DEPLOYMENT_SETUP_STORAGE_ENTRY = 231,
  DEPLOYMENT_SETUP_BUILD = 240,
  DEPLOYMENT_SETUP_BUILD_ENTRY = 241,
  DEPLOYMENT_SETUP_KUBERNETES = 250,
  DEPLOYMENT_SETUP_DOMAIN = 260,
  DEPLOYMENT_SETUP_DOMAIN_ENTRY = 261,
  DEPLOYMENT_SERVICES = 300,
  DEPLOYMENT_SERVICES_LEVEL1 = 301,
  DEPLOYMENT_SERVICES_LEVEL2 = 302,
}

export enum StatusItemInheritRule {
  OWN_STATE = 1,
  CHILDREN_COMBINED_STATE = 2,
}
